import { Chip } from '@mui/material';
import { AppMode } from '@k-ucap/shared';

export const ModeBadge = ({ mode }: { mode: AppMode }) => {
  const color = mode === AppMode.FIREBASE ? 'success' : mode === AppMode.MOCK ? 'warning' : 'error';
  return <Chip label={`Mode: ${mode}`} color={color} size="small" />;
};
